import { safeDecodeURIComponent } from 'tradera/utils/safe-decode-uri-component';

export const parseJwt = (token) => {
    if (!token) {
        return null;
    }
    // Copied from https://stackoverflow.com/a/38552302
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = safeDecodeURIComponent(
        window
            .atob(base64)
            .split('')
            .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
            .join('')
    );

    return JSON.parse(jsonPayload);
};
